import Cookies from "js-cookie";

class SharkAffiliate {
  getAffiliateRefFromCookie() {
    const affCookieName = "shark-affiliate";

    if (Cookies.get(affCookieName)) {
      return Cookies.get(affCookieName);
    }
    return null;
  }
}

export default new SharkAffiliate();
